module.exports = __webpack_public_path__ + "static/media/star-empty.aeb7bad4.svg";